import React from 'react';
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js';
import IconButtonUI from '../../../widgets/action/IconButtonUI.js';
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js';
import SearchUI from '../../../widgets/input/SearchUI.js';
import CustomerCreateModalSF from '../../../components/superUser/customer/CustomerCreateModalSF.js';
import CustomerUpdateModalSF from '../../../components/superUser/customer/CustomerUpdateModalSF.js';
import CardUI from '../../../widgets/layout/CardUI.js';
import BadgeUI from '../../../widgets/output/BadgeUI.js';

const CustomersPageUI = ({
  context, account, stateList, customerList, searchFilter, onSearchFilterChange,
  onRefreshClick, updateCustomerMode, onUpdateCustomerClick,
  createCustomerMode, onCreateCustomerClick, onCancelUpdateCustomer,
  onCancelCreateCustomer, selectedCustomer
}) => (
  <SuperUserAccountPageUI
    context={context} className='pg_su_cal' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!account}
    account={account} page='customers'
  >
    {!account && <SpinnerComponentUI />}
    {account && (
      <div>
        <LRTableActionsUI
          location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <IconButtonUI icon='icon-plus' onClick={onCreateCustomerClick} />
              <span className='g_m_left_100 g_large'><b>Customers</b></span>
            </div>
          }
          right={
            <div className='g_flex_h'>
              <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
            </div>
          }
        />
        <CardUI>
          <table className='g_full_width'>
            <thead>
              <tr>
                <th className='g_p_right_100'>Name</th>
                <th className='g_p_left_100'>PAN</th>
                <th className='g_p_left_100'>Contact</th>
                <th className='g_p_left_100'>Address</th>
                <th className='g_p_left_100'>Collection Due In Days</th>
              </tr>
            </thead>
            <tbody>
              {(customerList || []).map((customer, index) => (
                <CustomerRowUI key={index} context={context} customer={customer} onUpdateCustomerClick={onUpdateCustomerClick} />
              ))}
            </tbody>

          </table>
        </CardUI>
      </div>
    )}
    <CustomerCreateModalSF
      context={context} account={account}
      stateList={stateList}
      createMode={createCustomerMode}
      onCancelCreate={onCancelCreateCustomer}
      onRefreshClick={onRefreshClick}
    />
    <CustomerUpdateModalSF
      context={context} account={account}
      updateMode={updateCustomerMode}
      onCancelUpdate={onCancelUpdateCustomer}
      onRefreshClick={onRefreshClick}
      selectedCustomer={selectedCustomer}
    />
  </SuperUserAccountPageUI>
);

const CustomerRowUI = ({ context, customer, onUpdateCustomerClick }) => (
  <tr>
    <td className='g_p_right_100'>
      {customer.customerName || 'N/A'}
      <br />
      <span className='g_muted g_m_top_5'>{customer.customerId || 'N/A'}</span>
    </td>
    <td className='g_p_left_100'>{customer.panNumber || 'N/A'}</td>
    <td className='g_p_left_100'>
      <div>{customer.contactFirstName} {customer.contactLastName}</div>
      <div>Phone: {customer.contactPhone || 'N/A'}</div>
      <div>Email: {customer.contactEmail || 'N/A'}</div>
    </td>
    <td className='g_p_left_100'>
      {customer.addressList && customer.addressList.length > 0 ? (
        <>
          <div>{customer.addressList[0].city || 'N/A'}</div>
          <div>{customer.addressList[0].postalCode || 'N/A'}</div>
          <div>{customer.addressList[0].stateName || 'N/A'}</div>
        </>
      ) : 'N/A'}
    </td>
    <td className='g_p_left_100 g_text_right'>{customer.collectionDueInDays || 'N/A'}</td>
    <td className='g_p_left_100'>
      <span className='icon icon-pencil g_link_2 g_cursor_pointer' data-id={customer.customerId} onClick={onUpdateCustomerClick} />
      {customer.enableEscrow === true && (
        <div className='g_m_top_5'>
          <BadgeUI label='escrow' type='success' />
        </div>
      )}
    </td>
  </tr>
);

export default CustomersPageUI;
